import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  background: #ffebee;
  color: #c62828;
  padding: 20px;
  border-radius: 10px;
  margin: 20px 0;
  border-left: 4px solid #c62828;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const ErrorTitle = styled.div`
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 1.1em;
`;

const ErrorText = styled.div`
  line-height: 1.4;
`;

const ErrorMessage = ({ message, onRetry }) => {
    return (
        <ErrorContainer>
            <ErrorTitle>Error Loading Petition</ErrorTitle>
            <ErrorText>{message}</ErrorText>
        </ErrorContainer>
    );
};

export default ErrorMessage;